import { Component, OnInit, Input, Optional, Self, ElementRef, ViewChild } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';
import { PersonalDataModel } from '../../models/credit-card.model';
import { UfList } from '../../constants';




@Component({
  selector: 'intelli-customer-data-editor',
  templateUrl: './intelli-customer-data-editor.component.html',
  styleUrls: ['./intelli-customer-data-editor.component.css'],
  providers: [

    { provide: MatFormFieldControl, useExisting: IntelliCustomerDataEditorComponent },

  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class IntelliCustomerDataEditorComponent implements MatFormFieldControl<PersonalDataModel>, ControlValueAccessor {

  ufOptions: any[];
  editState: any;
  // @ViewChild('cardNumber',{static:true}) cardNumber: ElementRef;
  // @ViewChild('cardName',{static:true}) cardName: ElementRef;
  // @ViewChild('cardExpiry',{static:true}) cardExpiry: ElementRef;
  // @ViewChild('cardCvc',{static:true}) cardCvc: ElementRef;

  static nextId = 0;
  mainForm: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  errorState = false;
  controlType = 'intelli-text-editor';
  id = `intelli-customer-data-editor-${IntelliCustomerDataEditorComponent.nextId++}`;
  describedBy = '';
  private onChangeValue: (value: PersonalDataModel) => void;
  _value: PersonalDataModel;

 

  constructor(@Optional() @Self() public ngControl: NgControl,
    private _formBuilder: UntypedFormBuilder, private fm: FocusMonitor,
    private elRef: ElementRef<HTMLElement>) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.mainForm = _formBuilder.group( new PersonalDataModel());


    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });


    this.mainForm.valueChanges
      .subscribe(data => {

        console.log(data);
      //  this.onChangeValue(this.value);

      })

      this.ufOptions = UfList.getUfs().ToArray();
  }



  writeValue(obj: PersonalDataModel): void {


    this.value = obj;
  }
  registerOnChange(onChange: (value: PersonalDataModel) => void): void {

 
    this.onChangeValue = onChange;


  
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.mainForm.get("textControlName").disable();
    }
    else {
      this.mainForm.get("textControlName").enable();
    }
  }


  get empty() {
    
 
    return false;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);

    // if (this._disabled)
    //   this.mainForm.get("textControlName").disable()
    // else
    //   this.mainForm.get("textControlName").enable()

    // this.stateChanges.next();

    this.updateEditState();
  }
  private _disabled = false;

  @Input()
  get value(): PersonalDataModel | null {

    return this._value;

  }

  set value(value: PersonalDataModel | null) {

    this._value = value;
    

    this.updateGui();

    // setTimeout(() => {
    //   let event = new KeyboardEvent('keyup',{  "code": "5"});

    //   this.cardNumber.nativeElement.dispatchEvent(event);
    //   this.cardName.nativeElement.dispatchEvent(event);
    //   this.cardExpiry.nativeElement.dispatchEvent(event);
    //   this.cardCvc.nativeElement.dispatchEvent(event);

    // }, (1));




    
    this.stateChanges.next();
  }



  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {

  }

 public updateGui(): any {

console.log("update gui")
   if(this._value == null)
   {
     this._value =  new PersonalDataModel();
   }

    this.mainForm = this._formBuilder.group(this._value);


    this.mainForm
      .valueChanges
      .subscribe(() => {

        console.log("alterou")

        this.propagateChanges();
      }
      );

    //  this.testeccc();
  }

  public propagateChanges() {
    this._value = this.mainForm.value;

    if (this.onChangeValue != null) {

      console.log("mudou valor")
      this.onChangeValue(  this.value)
    }
  }



public updateEditState(): void {


  if (this._disabled) {

      Object.keys(this.mainForm.controls).forEach((key) => {
          this.mainForm.get(key).enable();
      });
  }
  else {

      Object.keys(this.mainForm.controls).forEach((key) => {

          // if (key == "Uf") {
          //     console.log(key);
          //     console.log( this.mainForm.get(key));
          //}

          this.mainForm.get(key).disable();

      });
  }
}

}